import { MenuItem } from '@core/models';
import { PropertyValidatorUtil } from '.';

export class MenuItemValidatorUtil {
	/**
	 * Valida que un menu item sea valido para el carrito.
	 */
	public static isValid(menuItem: MenuItem): boolean {
		// 'idCartItem', 'precio', 'cantidad', 'storeSlug'
		const keys: (keyof MenuItem)[] = ['idArticulo', 'nombre'];
		return !!menuItem && PropertyValidatorUtil.hasAllProperties(menuItem, keys);
	}
}
